<template>
    <div v-if="mostrarPainel" class="mt-2">
        <h4 class="heading-1">
            <span>Painéis</span>
        </h4>
        <b-list-group>
            <PainelPagamentosMensaisMenu></PainelPagamentosMensaisMenu>
        </b-list-group>
    </div>
</template>

<script>
import PainelPagamentosMensaisMenu from './pagamentosMensais/PainelPagamentosMensaisMenu.vue'

export default {
    components: {
        PainelPagamentosMensaisMenu
    },

    computed: {
        mostrarPainel() {
            return this.$temAcessoView('REL-PAGMEN-00')
        }
    }
}
</script>